const defaults = () => ({
  courseId: null,
  courseTitle: '',
});

export default {
  namespaced: true,
  persist: ['courseId', 'courseTitle'],
  state: defaults,
  mutations: {
    HYDRATE(state, payload) {
      Object.assign(state, payload);
    },
    SET_COURSE_ID(state, value) {
      state.courseId = value;
    },
    SET_COURSE_TITLE(state, value) {
      state.courseTitle = value;
    },
    RESET(state) {
      Object.assign(state, defaults());
    },
  },
};
